/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Swipe from 'react-easy-swipe';
import packageJson from '../../../package.json';
import { WHITE_CHEVRON } from '../../constants/urls';
import { useGlobalState } from '../context/qrState';
import { UserContext } from '../context/userContext';
import './sideDrawer.css';

import BackDrop from '../UI/backDrop/backDrop';
import {
  UserMail,
  UserImage,
  UserInfo,
  UserName,
  SideDrawerDiv,
  SideDrawerContentDiv,
  VersionDiv,
  // SideDrawerContent,
  ContentText,
  ContentLine,
  WhiteChevron,
} from './styles';
import { track } from '../../analytics/analytics';
import { EventIDs } from '../../analytics/events';
import { getSideDrawBizData } from '../../utils/businessDetails';

interface Props {
  closeSideDrawer: () => void;
  // showSideDrawer: boolean;
  openBusinessDrawer: () => void;
  openLogoutDraw: () => void;
}

const SideDrawer: React.FC<Props> = ({
  // showSideDrawer,
  closeSideDrawer,
  openBusinessDrawer,
  openLogoutDraw,
}) => {
  const { email } = useContext<Record<string, any>>(UserContext);
  const [showSideDrawer, setShowSideDrawer] = useGlobalState('sideDrawState');

  const { businessHierarchy, orgId } = useContext<Record<string, any>>(
    UserContext
  );
  const [bizName, setBizName] = useState(localStorage.getItem('BUSINESSNAME'));
  const [bizDetails, setBizDetails] = useState('');
  const history = useHistory();

  useEffect(() => {
    if (businessHierarchy && businessHierarchy.data.length !== 0) {

      let orgIdValue: string = businessHierarchy.data[0].id;

      // @ts-ignore
      if (localStorage.getItem('ORGID') && localStorage.getItem('ORGID') in businessHierarchy.businessDataStore) {
        // @ts-ignore
        orgIdValue = localStorage.getItem('ORGID');
      }

      if (orgId) {
        orgIdValue = orgId;
      }

      const { currentBizName, currentBizDetails } = getSideDrawBizData(
        businessHierarchy,
        orgIdValue
      );
      setBizName(currentBizName);
      setBizDetails(currentBizDetails);
    }
  }, [orgId, businessHierarchy]);

  useEffect(() => {
    if (showSideDrawer) {
      const payload = {
        email,
      };
      track(EventIDs.SIDE_DRAW, payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSideDrawer]);

  const onSwitchBusinessClick = () => {
    const payload = {
      email,
    };
    track(EventIDs.SWITCH_BUSINESS, payload);
    openBusinessDrawer();
    // @ts-ignore
    document.querySelector('#business')?.classList.add('highlighter');
    setTimeout(() => {
      // @ts-ignore
      document.querySelector('#business')?.classList.remove('highlighter');
    }, 500);
  };

  // const onUserMAnagementClick = () => {
  //   // @ts-ignore
  //   document.querySelector("#userManageMent")?.classList.add("highlighter");
  //   setTimeout(()=> {
  //     // @ts-ignore
  //     document.querySelector(`#userManageMent`)?.classList.remove('highlighter');
  //   }, 500);
  // };

  // const onHelpnSupportClick = () => {
  //   const payload = {
  //     email,
  //   };
  //   track(EventIDs.HELP_AND_SUPPORT, payload);
  //   // window.open('https://www.youtube.com/', '_blank');
  //   // @ts-ignore
  //   document.querySelector('#support')?.classList.add('highlighter');
  //   setTimeout(() => {
  //     // @ts-ignore
  //     document.querySelector('#support')?.classList.remove('highlighter');
  //   }, 500);
  // };

  const onFeedBackClick = () => {
    const payload = {
      email,
    };
    track(EventIDs.FEEDBACK, payload);
    history.push('/feedback');
    // window.open('https://www.youtube.com/', '_blank');
    // @ts-ignore
    document.querySelector('#feedback')?.classList.add('highlighter');
    setTimeout(() => {
      // @ts-ignore
      document.querySelector('#feedback')?.classList.remove('highlighter');
    }, 500);
    closeSideDrawer();
  };

  const onLogoutClick = () => {
    const payload = {
      email,
    };
    track(EventIDs.LOGOUT, payload);
    // @ts-ignore
    document.querySelector('logout')?.classList.add('highlighter');
    setTimeout(() => {
      // @ts-ignore
      document.querySelector('logout')?.classList.remove('highlighter');
    }, 500);
    openLogoutDraw();
  };

  let startX: number;
  let startY: number;

  const onSwipeStart = (event: any) => {
    if (event.changedTouches) {
      startX = event.changedTouches[0].pageX;
      startY = event.changedTouches[0].pageY;
    }
  };

  const onSwipeEnd = (event: any) => {
    if (event.changedTouches) {
      const endX = event.changedTouches[0].pageX;
      const endY = event.changedTouches[0].pageY;

      const X = Math.abs(endX - startX);
      const Y = Math.abs(endY - startY);

      if (X > 30 && Y <= 20 && startX > endX) {
        if (showSideDrawer) {
          setShowSideDrawer(!showSideDrawer);
        }
      }
    }
  };

  const eMail = email;
  return (
    <>
      <Swipe
        onSwipeStart={onSwipeStart}
        onSwipeEnd={onSwipeEnd}
        innerRef={() => { }}
      >
        <BackDrop show={showSideDrawer} clicked={closeSideDrawer} />
        <SideDrawerDiv isDrawerOpen={showSideDrawer}>
          <UserInfo>
            <UserImage>{eMail ? eMail.charAt(0).toUpperCase() : ''}</UserImage>
            <UserName>Hello,</UserName>
            {/* <UserPhone>+91 {userPhone}</UserPhone> */}
            <UserMail>{eMail}</UserMail>
          </UserInfo>
          <SideDrawerContentDiv>
            <div
              className="SideDrawerContent"
              id="business"
              onKeyDown={onSwitchBusinessClick}
              onClick={onSwitchBusinessClick}
            >
              <ContentText height={44}>
                <div
                  style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    width: '95%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span
                    style={{
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      width: '100%',
                      lineHeight: '160%',
                    }}
                  >
                    {bizName ? `Switch Business - ${bizName}` : `No business`}
                  </span>
                  {bizDetails && (
                    <span
                      style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        lineHeight: '160%',
                      }}
                    >
                      {bizDetails}
                    </span>
                  )}
                </div>
                <WhiteChevron src={WHITE_CHEVRON} alt="" />
              </ContentText>
              <ContentLine />
            </div>
            {/* <div className="SideDrawerContent"
          id="userManageMent"
          onKeyDown={onUserMAnagementClick}
              onClick={onUserMAnagementClick}>
            <ContentText
            >
              <span>User Access Management</span>
              <WhiteChevron src={WHITE_CHEVRON} alt="" />
            </ContentText>
            <ContentLine />
          </div> */}
            {/* <div
              className="SideDrawerContent"
              id="support"
              onKeyDown={onHelpnSupportClick}
              onClick={onHelpnSupportClick}
            >
              <ContentText>
                <span>Help & Support</span>
                <WhiteChevron src={WHITE_CHEVRON} alt="" />
              </ContentText>
              <ContentLine />
            </div> */}
            <div
              className="SideDrawerContent"
              id="feedback"
              onKeyDown={onFeedBackClick}
              onClick={onFeedBackClick}
            >
              <ContentText height={17}>
                <span>Give us Feedback</span>
                <WhiteChevron src={WHITE_CHEVRON} alt="" />
              </ContentText>
              <ContentLine />
            </div>

            <div
              className="SideDrawerContent"
              id="logout"
              onKeyDown={onLogoutClick}
              onClick={onLogoutClick}
            >
              <ContentText height={17}>
                <span>Logout</span>
                <WhiteChevron src={WHITE_CHEVRON} alt="" />
              </ContentText>
              <ContentLine />
            </div>
          </SideDrawerContentDiv>
          <VersionDiv>Version {packageJson.version}</VersionDiv>
        </SideDrawerDiv>
      </Swipe>
    </>
  );
};

export default SideDrawer;
